import type { FC } from 'react';
import type { AssignmentServiceRequest } from 'src/apis/assignment-service/use-assignment-service-root';
import { useOptionalCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { useDocumentExchange } from 'src/apis/document-exchange/use-document-exchange';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';
import type { Successful } from 'src/hooks/use-axios';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import type { UsePortal } from 'src/hooks/use-portal';

type Props = {
  actionPortal: UsePortal;
  assignmentService: Successful<AssignmentServiceRequest>;
};

export const ShippersTabs: FC<Props> = ({
  actionPortal,
  assignmentService,
}) => {
  const capacityManagementRoot = useOptionalCapacityManagementRoot();
  const documentExchange = useDocumentExchange();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  return (
    <Tabs data-testid="secondary-nav" actions={actionPortal.target}>
      {assignmentService.response.data._links.assignedUsers && (
        <Link to="/shippers/organisations-and-users">
          Organisations and Users
        </Link>
      )}

      {documentExchange?._links.getOperatorDocumentsOutbox?.href && (
        <Link to="/shippers/documents">Documents</Link>
      )}

      {!!capacityManagementRoot.response?.data._links?.invoicesV2 && (
        <Link to="/shippers/invoices">Invoices</Link>
      )}

      {monolithUser?.isOperator && (
        <Link to="/shippers/credit-limit">Credit Limits</Link>
      )}
    </Tabs>
  );
};
